
import TableTextInput from './TableTextInput'
import TableDateInput from './TableDateInput'

import TableImageInput from './TableImageInput'
import TabelGlobalUserInput from './TabelGlobalUserInput'
import TablePhoneInput from './TablePhoneInput'
import TableMultiSelectInput from './TableMultiSelectInput'
import TableSelectInput from './TableSelectInput'
import TablePriceInput from './TablePriceInput'
// import TablePriceInput from './TablePriceInput'
import TableStatusIndicator from './TableStatusIndicator'
import TableProfitCalculator from './TableProfitCalculator'
import TableCalculator from './TableCalculator'
import TableNumberInput from './TableNumberInput'
import TableTextAreaInput from './TableTextAreaInput'
import TableSwitchInput from './TableSwitchInput'
import TableFileInput from './TableFileInput'
import TableBooleanInput from './TableBooleanInput'
import TableSubformInput from './TableSubformInput'

const inputComponents = {
    // PhoneInput:TableTextInput,
    NumberInput:TableTextInput,
    PasswordInput:TableTextInput,
    CalendarRental:TableTextInput,
    TextInput:TableTextInput,
    BooleanInput:TableBooleanInput,
    SelectInput:TableSelectInput,
    TextAreaInput:TableTextInput,
    ProfileImageInput:TableTextInput,
    SelectListInput:TableTextInput,
    CheckboxInput:TableTextInput,
    FromToInput:TableTextInput,
    PriceInput:TablePriceInput,
    // SubformInput:TableSubformInput,
    SliderInput:TableTextInput,
    AdvancedSelectInput:TableSelectInput,
    MultiSelectInput:TableMultiSelectInput,
    ImageInput:TableImageInput,
    DateInput:TableDateInput,
    GlobalUserInput:TabelGlobalUserInput,
    PhoneInput:TablePhoneInput,
    SwitchInput:TableSwitchInput,
    NewStatusIndicator:TableStatusIndicator,
    StatusIndicator:TableStatusIndicator,
    ProfitCalculator:TableProfitCalculator,
    Calculator:TableCalculator,
    NumberInput:TableNumberInput,
    TextAreaInput:TableTextAreaInput,
    FileInput:TableFileInput,
    MultiLevelInput:TableMultiSelectInput,
    MultiTreeSelectAddListing:TableMultiSelectInput

}

export default (inputComponents);